/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roomannouncementplaceholder2Inputs */

const en_roomannouncementplaceholder2 = /** @type {(inputs: Roomannouncementplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Two drinks for the price of one at the bar until 10 pm`)
};

const de_roomannouncementplaceholder2 = /** @type {(inputs: Roomannouncementplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Bis 22 Uhr zwei Getränke zum Preis von einem an der Bar`)
};

/**
* | output |
* | --- |
* | "e.g. Two drinks for the price of one at the bar until 10 pm" |
*
* @param {Roomannouncementplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const roomannouncementplaceholder2 = /** @type {((inputs?: Roomannouncementplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roomannouncementplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roomannouncementplaceholder2(inputs)
	return de_roomannouncementplaceholder2(inputs)
});
export { roomannouncementplaceholder2 as "roomAnnouncementPlaceholder" }